export const canShareBookUploads = userId => userId === '4312f009-7502-43a6-9483-2824508fe96f';
